import Mutations from '../../odata/mutations';

export default { ...new Mutations('candidate'), ...new Mutations('candidates') };
